import { AbstractControl, ValidationErrors } from '@angular/forms';

export function spanishDniNieValidator() {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value || '').toUpperCase().trim();

    if (!value) return null; // no validar si està buit (permet required separat)

    const dniRegex = /^(\d{8})([A-Z])$/;
    const nieRegex = /^[XYZ](\d{7})([A-Z])$/;
    const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';

    let numberPart: number;
    let letterProvided: string;

    // DNI
    if (dniRegex.test(value)) {
      const match = value.match(dniRegex);
      if (!match) return { invalidDniNie: true };

      numberPart = parseInt(match[1], 10);
      letterProvided = match[2];

      const letterCorrect = letters[numberPart % 23];
      return letterProvided === letterCorrect ? null : { invalidDniNie: true };
    }

    // NIE (X/Y/Z)
    if (nieRegex.test(value)) {
      const match = value.match(nieRegex);
      if (!match) return { invalidDniNie: true };

      const prefix = value[0];
      const map = { X: '0', Y: '1', Z: '2' } as const;

      numberPart = parseInt(map[prefix as 'X' | 'Y' | 'Z'] + match[1], 10);
      letterProvided = match[2];

      const letterCorrect = letters[numberPart % 23];
      return letterProvided === letterCorrect ? null : { invalidDniNie: true };
    }

    return { invalidDniNie: true };
  };
}
